import React, { useState, useEffect } from 'react';
import UnderConstruction from '../../components/UnderConstruction';
import DashboardHeader from '../../components/DashboardHeader';
import DashboardFooter from '../../components/DashboardFooter';
import { FaBookReader } from 'react-icons/fa';
import './adm_assignments.css';
import { auth } from '../../auth/firebase';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../auth/firebase';
import cacheManager from '../../auth/cache_manager';

const AdminAssignments = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  // # Load theme preference from user data on initial render
  useEffect(() => {
    const loadThemePreference = async () => {
      if (auth.currentUser?.uid) {
        // # Try to get from cache first
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData && userData.themes && userData.themes.gen_theme !== undefined) {
          setIsDarkMode(userData.themes.gen_theme === 'dark');
        }
      }
    };
    
    loadThemePreference();
  }, []);

  // # Handle theme toggle
  const handleThemeToggle = async () => {
    try {
      const newTheme = !isDarkMode;
      setIsDarkMode(newTheme);
      
      // # Update theme in Firebase if user is logged in
      if (auth.currentUser?.uid) {
        // # Update the user document
        await updateDoc(doc(db, 'users', auth.currentUser.uid), {
          'themes.gen_theme': newTheme ? 'dark' : 'light'
        });
        
        // # Update cache manager
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData) {
          const updatedUserData = {
            ...userData,
            themes: {
              ...(userData.themes || {}),
              gen_theme: newTheme ? 'dark' : 'light'
            }
          };
          cacheManager.set(`user_${auth.currentUser.uid}`, updatedUserData);
        }
      }
    } catch (error) {
      console.error('Error updating theme preference:', error);
    }
  };

  return (
    <div className={`assign_container ${isDarkMode ? 'assign_dark_mode' : ''}`}>
      <DashboardHeader isDarkMode={isDarkMode} onThemeToggle={handleThemeToggle} />
      
      <div className="assign_content">
        <div className="assign_header">
          <div className="assign_icon_wrapper">
            <FaBookReader className="assign_icon" />
          </div>
          <h1>Assignment Bank</h1>
        </div>
        <UnderConstruction pageName="Assignment Bank" />
      </div>

      <DashboardFooter isDarkMode={isDarkMode} />
    </div>
  );
};

export default AdminAssignments;
